const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '多节点CDN加速，点击即播无需等待。智能预加载技术，追剧流畅不卡顿。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '支持1080P超清播放，自适应码率切换。无论网速快慢，始终给您最佳清晰度。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '与播出平台同步上线，热门剧集更新后第一时间呈现。追剧日历自动提醒。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告、无恶意插件、无强制跳转。纯净观影环境，专注内容本身。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '电脑、平板、手机全终端兼容。一处追剧，多设备无缝切换，进度云端同步。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-600">为什么千万剧迷选择番茄影视大全</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center group hover:border-primary-300 transition-all"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}